module.exports = __webpack_public_path__ + "img/dcs_pic_1.19f08896.jpg";